export type PersonNameOrder = 'given-first' | 'family-first';

type FormatPersonNameShortOptions = {
  order?: PersonNameOrder;
  emptyFallback?: string;
};

export function formatPersonNameShort(
  fullName: string | null | undefined,
  options?: FormatPersonNameShortOptions,
): string {
  const { order = 'family-first', emptyFallback = '' } = options ?? {};

  if (!fullName?.trim()) {
    return emptyFallback;
  }

  const parts = fullName.trim().split(/\s+/);
  if (parts.length === 1) {
    return parts[0];
  }

  const [firstName, lastName] = order === 'given-first'
    ? [parts[0], parts[1]]
    : [parts[1], parts[0]];

  if (!lastName) {
    return fullName.trim();
  }

  return `${firstName} ${lastName[0]}.`;
}

export function formatOwnerNameShort(fullName: string | null | undefined): string {
  return formatPersonNameShort(fullName, {
    order: 'given-first',
    emptyFallback: 'Имя владельца не указано',
  });
}

export function formatPersonInitials(fullName: string | null | undefined): string {
  const parts = (fullName || '')
    .replace(/[^\p{L}\s]/gu, ' ')
    .split(/\s+/)
    .filter(Boolean);

  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }

  return (parts[0] || '?').slice(0, 2).toUpperCase();
}
